import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {  apiToken, callBackendUrl } from "../../../utils/config";
import { start } from "@popperjs/core";

// Initial state
const initialState = {
  value: [],
  status: "idle",
  error: null,
  lastAssistantId: null,
};

// Async thunk to fetch call data
export const fetchCalls = createAsyncThunk(
  "conversations/fetchCalls",
  async (paramsData) => {
    let { assistantId = "", createdAt } = paramsData;

    let url = `${callBackendUrl}?assistantId=${assistantId}`;
    if (createdAt) {
      url += `&createdAtLe=${createdAt}`;
    }

    const response = await fetch(url, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${apiToken}`,
      },
    });

    const data = await response.json();
    return data["calls"];
  }
);


const conversationSlice = createSlice({
  name: "conversations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchCalls.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchCalls.fulfilled, (state, action) => {
        state.status = "succeeded";
        const assistantId = action.payload[0]?.assistantId;
        if (state.lastAssistantId === assistantId) {
          state.value = [...state.value, ...action.payload];
        } else {
         state.value = action.payload;
          state.lastAssistantId = assistantId;
        }
      })
      .addCase(fetchCalls.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default conversationSlice.reducer;
